import React, { Component } from "react"
import SelectedHeader from "../../part/user/selectedCourse_Header"
import { FaAngleLeft } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa6";
import { LuListChecks } from "react-icons/lu";
import { LiaTimesSolid } from "react-icons/lia";
import { FaAngleDown } from "react-icons/fa6";
import { FaRegSquare } from "react-icons/fa";
import CourseReview from "../../part/user/course.review";


class SelectedCourse extends Component {
    state = {
        contentMenu: "overview",
        listContent : 1,
        openResourceId: null
    }
    handleContentMenu = (value) => {
        this.setState({
            contentMenu: value
        })
    }
    handleListContent = (value) =>{
        if(this.state.listContent === value ){
            this.setState({
            listContent: 0
        })
        }else{
        this.setState({
            listContent: value
        })
    }}
    handleResourceDropdown = (e, uniqueId) => {
    e.stopPropagation(); 
    this.setState({
        openResourceId: this.state.openResourceId === uniqueId ? null : uniqueId
    });
}
    render() {
        const { contentMenu, listContent, openResourceId } = this.state
        return (
            <>
                <SelectedHeader />
                <div className="selected_course_body">
                    <section className="selected_container left">
                        <div className="select_list_head">
                            <h3>Course Content</h3>
                            <button><LiaTimesSolid /></button>
                        </div>
                        <div className="select_list_body">
                            <section className="selected_content_cover">
                                <div className="main_list_content" onClick={() => this.handleListContent(1)}>
                                    <div className="list_writeup">
                                        <h4>Module 1 : Becoming what you deserve </h4>
                                        <span>0/12 | 2hr 30min</span>
                                    </div>
                                    <FaAngleDown />
                                </div>
                                <div className={listContent === 1 ? "sub_list_cover active" : "sub_list_cover"}>
                                    <div className="main_list_content sub">
                                        <FaRegSquare />
                                        <div className="list_writeup">
                                            <h4>Module 1 : Becoming what you deserve </h4>
                                            <div className="list_bottom">
                                                <span>2hr 30min</span>
                                                <div style={{ position: "relative" }}>
                                                    <button className="dropdown_button" onClick={(e) => this.handleResourceDropdown(e, "m1-l1")}>Resources <FaAngleDown /></button>
                                                    { openResourceId === "m1-l1" ?
                                                    <div className="selected_course_dropdown">
                                                        <div className="dropdown_cover">
                                                            <li>Document</li>
                                                            <li>Zip</li>
                                                            <li>PDF</li>
                                                        </div>
                                                    </div> : 
                                                    null}

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="main_list_content sub">
                                        <FaRegSquare />
                                        <div className="list_writeup">
                                            <h4>Module 1 : Becoming what you deserve </h4>
                                            <div className="list_bottom">
                                                <span>2hr 30min</span>
                                                <div style={{ position: "relative" }}>
                                                    <button className="dropdown_button">Resources <FaAngleDown /></button>
                                                    {/* <div className="selected_course_dropdown">
                                                        <div className="dropdown_cover">
                                                            <li>Document</li>
                                                            <li>Zip</li>
                                                            <li>PDF</li>
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="main_list_content sub">
                                        <FaRegSquare />
                                        <div className="list_writeup">
                                            <h4>Module 1 : Becoming what you deserve </h4>
                                            <div className="list_bottom">
                                                <span>2hr 30min</span>
                                                <div style={{ position: "relative" }}>
                                                    <button className="dropdown_button">Resources <FaAngleDown /></button>
                                                    {/* <div className="selected_course_dropdown">
                                                        <div className="dropdown_cover">
                                                            <li>Document</li>
                                                            <li>Zip</li>
                                                            <li>PDF</li>
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </section>

                            <section className="selected_content_cover">
                                <div className="main_list_content" onClick={() => this.handleListContent(2)}>
                                    <div className="list_writeup">
                                        <h4>Module 2 : Becoming what you deserve </h4>
                                        <span>0/12 | 2hr 30min</span>
                                    </div>
                                    <FaAngleDown />
                                </div>
                                <div className={listContent === 2 ? "sub_list_cover active" : "sub_list_cover"}>
                                    <div className="main_list_content sub">
                                        <FaRegSquare />
                                        <div className="list_writeup">
                                            <h4>Module 1 : Becoming what you deserve </h4>
                                            <div className="list_bottom">
                                                <span>2hr 30min</span>
                                                <div style={{ position: "relative" }}>
                                                    <button className="dropdown_button">Resources <FaAngleDown /></button>
                                                    {/* <div className="selected_course_dropdown">
                                                        <div className="dropdown_cover">
                                                            <li>Document</li>
                                                            <li>Zip</li>
                                                            <li>PDF</li>
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="main_list_content sub">
                                        <FaRegSquare />
                                        <div className="list_writeup">
                                            <h4>Module 1 : Becoming what you deserve </h4>
                                            <div className="list_bottom">
                                                <span>2hr 30min</span>
                                                <div style={{ position: "relative" }}>
                                                    <button className="dropdown_button">Resources <FaAngleDown /></button>
                                                    {/* <div className="selected_course_dropdown">
                                                        <div className="dropdown_cover">
                                                            <li>Document</li>
                                                            <li>Zip</li>
                                                            <li>PDF</li>
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="main_list_content sub">
                                        <FaRegSquare />
                                        <div className="list_writeup">
                                            <h4>Module 1 : Becoming what you deserve </h4>
                                            <div className="list_bottom">
                                                <span>2hr 30min</span>
                                                <div style={{ position: "relative" }}>
                                                    <button className="dropdown_button">Resources <FaAngleDown /></button>
                                                    {/* <div className="selected_course_dropdown">
                                                        <div className="dropdown_cover">
                                                            <li>Document</li>
                                                            <li>Zip</li>
                                                            <li>PDF</li>
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </section>
                        </div>
                    </section>





                    <section className="selected_container right">

                        <div className="selected_video">
                            <div className="Nextbutton">
                                <button><FaAngleLeft /></button>
                                <button><FaAngleRight /></button>
                            </div>
                        </div>


                        <div className="selected_content">
                            <nav className="selected_menu">
                                <div className="selected_menu_cover">
                                    <LuListChecks />
                                    <button className={contentMenu === "overview" ? "active" : null} onClick={() => this.handleContentMenu("overview")}>Overview</button>
                                    <button className={contentMenu === "q&a" ? "active" : null} onClick={() => this.handleContentMenu("q&a")}>Q&A</button>
                                    {/* <button>Notes</button> */}
                                    <button className={contentMenu === "announce" ? "active" : null} onClick={() => this.handleContentMenu("announce")}>Announcement</button>
                                    <button className={contentMenu === "review" ? "active" : null} onClick={() => this.handleContentMenu("review")}>Reviews</button>
                                    <button className={contentMenu === "tools" ? "active" : null} onClick={() => this.handleContentMenu("tools")}>Learning tools</button>
                                </div>
                            </nav>



                            <div className="selected_course_writeup">
                                {contentMenu === "overview" ?
                                    <div className="selected_writeup_cover">
                                        <h2 className="head">About this course</h2>
                                        <p>
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                            Amet accusantium neque atque error distinctio quasi eligendi commodi ea aliquid,
                                            debitis minima dicta iure accusamus sunt et, quae soluta? Quod ea distinctio qui repellendus.
                                            Porro, corporis sed dolor obcaecati nemo in. <br /><br />

                                            Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                            Amet accusantium neque atque error distinctio quasi eligendi commodi ea aliquid,
                                            debitis minima dicta iure accusamus sunt et, quae soluta? Quod ea distinctio qui repellendus.
                                            Porro, corporis sed dolor obcaecati nemo in.
                                        </p>
                                    </div> : null}


                                    {contentMenu === "announce" ?
                                    <div className="selected_writeup_cover">
                                        <h2 className="head">Announcement</h2>
                                        <p>
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                            Amet accusantium neque atque error distinctio quasi eligendi commodi ea aliquid,
                                            debitis minima dicta iure accusamus sunt et, quae soluta? Quod ea distinctio qui repellendus.
                                            Porro, corporis sed dolor obcaecati nemo in. <br /><br />

                                            Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                            Amet accusantium neque atque error distinctio quasi eligendi commodi ea aliquid,
                                            debitis minima dicta iure accusamus sunt et, quae soluta? Quod ea distinctio qui repellendus.
                                            Porro, corporis sed dolor obcaecati nemo in.
                                        </p>
                                    </div> : null}


                                {contentMenu === "review" ?
                                    <div className="selected_writeup_cover">
                                        <CourseReview width="full_width" />
                                    </div>
                                    : null}



                            </div>

                        </div>
                    </section>
                </div>
            </>
        )
    }
}


export default SelectedCourse